import { Injectable, isDevMode } from '@angular/core';
import { CanActivate, CanActivateChild, Router } from '@angular/router';

@Injectable()
export class AuthService implements CanActivate, CanActivateChild {
  constructor(private router: Router) {}

  canActivate(): boolean {
    return this.checkLogin();
  }

  canActivateChild(): boolean {
    return this.checkLogin();
  }

  checkLogin(): boolean {
    if (isDevMode()) {
      if (sessionStorage && sessionStorage.getItem('versionId') !== null) {
        return true;
      }
      this.router.navigate(['/login']);
      return false;
    } else {
      return true;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/services/auth.service.ts